// extracted by mini-css-extract-plugin
export var checkbox = "_3a-0";
export var circle = "_3a-3";
export var horizontalContainer = "_3a-7";
export var sm = "_3a-5";
export var switch0 = "_3a-2";
export var switchDisabled = "_3a-8";
export var switchEnabled = "_3a-1";
export var textSwitchContainer = "_3a-9";
export var textSwitchOption = "_3a-a";
export var textSwitchOptionSelected = "_3a-b";
export var verticalContainer = "_3a-6";
export var xs = "_3a-4";